// var xhrSearchProducts;
var xhrSearchStores;
var xhrSearchUsers;
var xhrSearchCats;

var delayAction = (function() {
	var timer = 0;
	return function (callback, ms) {
		clearTimeout(timer);
		timer = setTimeout(callback, ms);
	};
})();

/* Search function */
$(document).on('keyup', '.sitewide-search', function() {
	// var input_id = $(this).attr('id')
	// var input = $("#"+input_id)
	// var query = input.val();
	var query = $(this).val()
	// console.log(input_id);
	console.log("Detecting URLs for "+ query);
	$(this).parents('.search-container').removeClass('url-detected')
	$('.search-query').html($(this).val())
	if (/https?:\/\/.+/i.test(query)) {
		// console.log("URL detected");
		$(this).parents('.search-container').addClass('url-detected')
	} else {
		// console.log("Not a url");
		$(this).parents('.search-container').removeClass('url-detected')
		// delayAction(function () {
		// 	searchAll(input_id);
		// }, 500);
	}
});

$(document).on('submit', '.search-container form', function(e) {
	if ($('.stores-search-result li').length == 1) {
		e.preventDefault();
		window.location.href = $('.stores-search-result li a').attr('href')
	}
});

$(document).on('keyup', 'input.store-search', function() {
	var query = $(this).val();
	var input_id = $(this).attr('id')

	delayAction(function () {
		searchStoresList(input_id);
	}, 500);
});

$(document).on('keyup', 'input.user-search', function() {
	var query = $(this).val();
	var input_id = $(this).attr('id')

	delayAction(function () {
		self.searchUsersList(input_id);
	}, 500);
});


var searchStoresList = function(input_id) {
	var input = $("#"+input_id)
	var query = input.val();

		if(xhrSearchStores && xhrSearchStores.readyState != 4){
			xhrSearchStores.abort();
		}
		xhrSearchStores = $.ajax({
			url: '/stores_list',
			data: { query: query },
			type: 'GET',
			success: function (data) {
				if (data) {
					input.parents('.search-container').find('.stores-list').html(data)
				} else {
				}
			}
		});
};

var searchUsersList = function(input_id) {
	var input = $("#"+input_id)
	var query = input.val();

	// if (query.length >= 1) {
		if(xhrSearchUsers && xhrSearchUsers.readyState != 4){
			xhrSearchUsers.abort();
		}
		xhrSearchUsers = $.ajax({
			url: '/users_list',
			data: { query: query },
			type: 'GET',
			// dataType: 'json',
			success: function (data) {
				// console.log(data);
				if (data) {
					input.parents('.search-container').find('.users-list').html(data)
				}
			}
		});
	// }
};


var searchAll = function(input_id) {
	var input = $("#"+input_id)
	var query = input.val();

	if (query.length >= 3) {
		// if(xhrSearchProducts && xhrSearchProducts.readyState != 4){
		// 	xhrSearchProducts.abort();
		// }
		if(xhrSearchUsers && xhrSearchUsers.readyState != 4){
			xhrSearchUsers.abort();
		}
		if(xhrSearchCats && xhrSearchCats.readyState != 4){
			xhrSearchCats.abort();
		}
		xhrSearchProducts = $.ajax({

		});

		xhrSearchUsers = $.ajax({
			url: '/users',
			data: { query: query },
			type: 'GET',
			dataType: 'json',
			success: function (data) {
				// console.log(data);
				if (data) {
					var html1 = "";
					var users = data;
					if (users != "") {
						// html1 += '<h6>USERS</h6>';
						for (var index = 0; index < users.length; index++) {
							var user = users[index]
							html1 += '<li>'
							html1 += '<a href="'+user['url']+'">'
							html1 += '<div class="avatar-wrapper">'
							html1 += '<img src="'+user['image']+'" class="avatar">'
							html1 += '</div>'
							html1 += '<div class="right">'
							html1 += '<h5>'
							html1 += user['username']
							html1 += '</h5>'
							html1 += '<p>'
							html1 += user['full_name']
							html1 += '</p>'
							html1 += '</div>'
							html1 += '</a>'
							html1 += '</li>';
						}
					} else {
						html1 += ''
					}
					$('.users-search-result').html(html1);
				} else {
				}
			}
		});
	} else {
		input.parents('.search-container').removeClass('url-detected')
		$('.categories-search-result').html("");
		$('.products-search-result').html("");
		$('.users-search-result').html("");
	}
};


$(".product-list").on("click", ".content-list-item", function (event) {
	var product_id = this.getAttribute('data-product-id');
	var inspiration_id = this.getAttribute('data-inspiration-id');

	if(amIclicked(event, this))
	{
			// console.log('One is clicked');
			if(inspiration_id) {
				$.featherlight($('#show-product-'+inspiration_id), {variant: 'full-screen'});
			} else {
				$.featherlight($('#show-product-'+product_id), {variant: 'full-screen'});
			}
	}

});

$("#inspiration-list").on("click", ".content-list-item", function (event) {
	var inspiration_id = this.getAttribute('data-inspiration-id');
	$.featherlight($('#show-inspiration-'+inspiration_id), {variant: 'variant-inspiration'});
});
